export const GET_CURRENCY = "GET_CURRENCY";
export const TOGGLE_STATE = "TOGGLE_STATE";
export const GET_TOTAL_SUPPLY_USD = "GET_TOTAL_SUPPLY_USD";
export const GET_TOTAL_SUPPLY_KRW = "GET_TOTAL_SUPPLY_KRW";
